// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"FauxButton-primaryButton-1tuXJl","button":"FauxButton-button-Li7yrO"};